import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";

export default function Map({ data, capability }) {
  let position = [51.505, -0.09];

  let lat, lng;
  if (
    capability &&
    typeof capability.value === "object" &&
    Array.isArray(capability.value) &&
    capability.value.length >= 2
  ) {
    lat = parseFloat(capability.value[0]);
    lng = parseFloat(capability.value[1]);
  } else if (
    capability &&
    Array.isArray(capability.array_value) &&
    capability.array_value.length >= 2
  ) {
    lat = parseFloat(capability.array_value[0]);
    lng = parseFloat(capability.array_value[1]);
  }

  if (
    typeof lat === "number" &&
    typeof lng === "number" &&
    !isNaN(lat) &&
    !isNaN(lng)
  ) {
    position = [lat, lng];
  }

  return (
    <MapContainer
      center={position}
      zoom={13}
      scrollWheelZoom={false}
      style={{ height: "90%", width: "100%" }}
      className="mt-2"
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      <Marker position={position}>
        <Popup>
          Coordinates: {position[0]}, {position[1]}
        </Popup>
      </Marker>
    </MapContainer>
  );
}
